export default ['ingredient', 'quantity'];
